import axios from "axios";

export const getCompanyDetail = async (slug) => {
  const COMPANY_DETAIL_PAGE_SIZE = 9;
  const apiBaseUrl = typeof window !== "undefined" ? window.env.EJ_APPS_SEARCH_API : process.env.EJ_APPS_SEARCH_API;
  const url = `${apiBaseUrl}/search/v1/project/company/${slug}?pageSize=${COMPANY_DETAIL_PAGE_SIZE}`;
  const response = await axios.get(url);
  return response.data;
};

export const getCompanyDetailForClient = async (slug, listingPage) => {
  const COMPANY_DETAIL_CLIENT_PAGE_SIZE = 9;
  const apiBaseUrl = typeof window !== "undefined" ? window.env.EJ_APPS_SEARCH_API : process.env.EJ_APPS_SEARCH_API;
  const url = `${apiBaseUrl}/search/v1/project/company/${slug}/${listingPage}/?pageSize=${COMPANY_DETAIL_CLIENT_PAGE_SIZE}`;
  const response = await axios.get(url);
  return response.data;
};
